import "../../assets/sass/bootstrap.scss";

import React, {Component} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import {
    Popover, PopoverHeader, PopoverBody
} from 'reactstrap';
import PolyUtil from "../../util/PolyUtil";

class UserBubble extends Component {
    state = {
        showPopover: false,
        popId: null
    };

    colors = [
        "#f28920", "#49b75e", "#33ccb6", "#d13b7f", "#733aef", "#c8d60b", "#598ece", "#ea537a", "#dd9c4e",
        "#6da877", "#b4f741", "#7775cc", "#8ca579", "#2c57f4", "#dd9c5b", "#e8e862", "#d11c4b", "#d3b34a",
        "#4cd39f", "#599bfc", "#4eea95", "#ea47a8", "#c46f55", "#2588bf", "#6d6457", "#7e649e"
    ];

    componentWillMount() {
        this.setState({popId: PolyUtil.guid()});
    }

    togglePopover = () => {
        this.setState({showPopover: !this.state.showPopover});
    };

    render() {
        const {color, disabled, initials, label, popover, onClick, dark, small, margin, highlight} = this.props;
        const containerClassName = classnames('user-bubble-container');
        const bubbleClassName = classnames('user-bubble', {'user-bubble-small': small, 'user-bubble-dark': dark, 'user-bubble-disabled': disabled});

        let borderColor = 'white';
        if (color === 'success') borderColor = '#27a152';
        else if (color === 'danger') borderColor = '#d5656b';
        else if (color === 'warning') borderColor = '#f78d1e';
        else if (color === 'grey') borderColor = '#d9d9d9';

        const initialClassName = classnames({
            'text-success': highlight
        });

        //backgroundColor = badgeColors[("{{ user.last_name|index:0|title }}".charCodeAt() - 65) % 26]

        // console.log("Color: " + !!text && this.colors[parseInt(label.charAt(0), 10) % 26]);
        // const text = label || initials;

        return (
            <div className={containerClassName} onClick={onClick || (popover && this.togglePopover)} style={margin && {margin: margin}}>
                <div id={this.state.popId} className={bubbleClassName} style={{borderColor: borderColor}}>
                    <span className={initialClassName}>{initials || (label && label.charAt(0))}</span>
                </div>
                {
                    label && (
                        <div className="user-bubble-label" style={{color: dark && '#374245'}}>
                            {label}
                        </div>
                    )
                }
                {
                    (popover && !disabled) && (
                        <Popover className="animated fadeIn" placement="bottom" isOpen={this.state.showPopover} target={this.state.popId} toggle={this.togglePopover}>
                            <PopoverHeader>{popover.title}</PopoverHeader>
                            <PopoverBody>{popover.content}</PopoverBody>
                        </Popover>
                    )
                }
            </div>
        );

    }
}

UserBubble.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    initials: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    popover: PropTypes.object,
    dark: PropTypes.bool,
    small: PropTypes.bool,
    margin: PropTypes.string,
    highlight: PropTypes.bool
};

export default UserBubble;


// WEBPACK FOOTER //
// ./src/components/user/UserBubble.js